import laurelUrl from "./castalia-laurel-full-clean.svg";
import waterfallUrl from "./castalia-waterfall-avatar.svg";
import waterfallBoldUrl from "./castalia-waterfall-bold.png";

// Cas's mark, A/B-swappable in code (U.10): every CasLogo (the app-bar toggle
// and her avatar in the thread) renders CAS_MARKS[CAS_MARK]. To swap, change
// CAS_MARK below; every file stays in src/components/brand.
//   laurel        — castalia-laurel-full-clean.svg: the original Cas mark,
//                   laurel profile in dark ink on the magenta disc (U.9).
//   waterfall     — castalia-waterfall-avatar.svg: the waterfall figure
//                   framed head-and-shoulders (U.8).
//   waterfallBold — castalia-waterfall-bold.png: the waterfall redrawn with
//                   bold strands so she reads at avatar size (U.13, U.17),
//                   made by gen-cas-waterfall-bold.py from the user's image.
export type CasMarkName = "laurel" | "waterfall" | "waterfallBold";

export const CAS_MARKS: Record<CasMarkName, string> = {
  laurel: laurelUrl,
  waterfall: waterfallUrl,
  waterfallBold: waterfallBoldUrl,
};

export const CAS_MARK: CasMarkName = "waterfallBold";
